<template>
  <div v-if="showDeleteButton" style="margin-left: 5px;">
    <span style="color: red;cursor: pointer;" @click="delOneContent(postId)">删除</span>
  </div>
</template>

<script>
export default {
  props: {
    postId: Number,
    userOwnThePost: Boolean
  },
  data () {
    return {
      showDeleteButton: false
    }
  },
  mounted: async function () {
    if (this.userOwnThePost) {
      this.showDeleteButton = true
    } else {
      this.showDeleteButton = false
    }
  },
  methods: {
    delOneContent: async function (postId) {
      const com = confirm('确定删除此内容吗?')
      if (com) {
        const api = '/md/front/bbs/feedback/postManage/main/del'
        let params = {
          postId: postId
        }
        params = this.$qs.stringify(params)
        const res = await this.axios.post(api, params)
        if (res.status === 200) {
          this.$emit('flushDateEvent')
        } else {
          alert('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped></style>
